<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" style="width: 15px;margin-right: 5px;" />트링카 크레딧 안내</span>
                        <h1>트링카 기능을 필요에 따라 사용할 수 있는 유연성
                        </h1>
                        <p>크레딧은 다양한 트링카 기능을 필요에 따라 사용하도록 유연성을 제공해
                            <br>드리는 토큰과 같습니다. 매달 무료 크레딧을 받아보세요!
                        </p>
                        <a href="https://cloud.trinka.ai/signup?_rg=KR" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/CreditInformation.png" alt="credit">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>좋아하는 기능에 크레딧 사용하기</h2>
                        <div class="HeadingSubLine"></div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_feature">
                        <table class="table">
                            <thead>
                                <tr class="odd">
                                    <th>기능</th>
                                    <th class="text-center">
                                        <sup>
                                            <img style="width: 20px;" src="../../../../assets/images/credits_icon.png" />
                                        </sup>사용 크레딧
                                    </th>
                                </tr>
                            </thead>
                            <tr>
                                <td>
                                    <h5>트링카 표절 검사</h5>
                                    <p>인터넷 출처 및 일부 오픈액세스 출판물에 대해 iThenticate에서 제공하는 최고 품질의 표절 검사를 받아보세요.
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">보고서 건당 12크레딧
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>iThenticate 표절 검사</h5>
                                    <p>인터넷, 오픈액세스, 유료 출판물에 대해 iThenticate에서 제공하는 최고 품질의 표절 검사를 받아보세요.
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">보고서 건당 18크레딧
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>자동 파일 편집</h5>
                                    <p>몇 분 내에 MS Word 파일을 자동으로 편집하고 모든 변경 사항을 추적하여 표시한 변경 파일을 다운로드합니다.
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center" style="font-size: 16px;">한 파일 내 5000단어 당 1크레딧
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>출판 준비 체크</h5>
                                    <p>저널 선정, 윤리기준 준수 등 20가지 이상의 체크포인트로
                                        <br>문서의 출판 준비 상태를 평가합니다.
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center" style="font-size: 16px;">모든 보고서 건당 1크레딧
                                    </p>
                                </td>
                            </tr>

                            <!-- <tr>
                                <td>
                                    <h5>Plagiarism Checker</h5>

                                    <p>Avoid unintentional plagiarism in your content. Choose from multiple plagisrism checkers,
                                        including iThenticate.
                                    </p>
                                </td>
                                <td>
                                    <p class="text-center"  style="font-size: 16px;">Starts from 3 credits for<br />every check
                                    </p>
                                </td>
                            </tr>

                            <tr>
                                <td class="odd">
                                    <h5>Referrence Quality Check</h5>
                                    <p>Avoid using poor-quality citations and strengthen your argumentation with multiple quality
                                        checks for your reference list.
                                    </p>
                                </td>
                                <td class="odd">
                                    <p class="text-center"  style="font-size: 16px;">3 credits for every file</p>
                                </td>
                            </tr> -->

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="creadits_availability">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>
                            <sup>
                                <img style="width: 22px;" src="../../../../assets/images/credits_icon.png" />
                            </sup> 사용 가능한 크레딧</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin: 0;">모든 트링카 사용자에게는 30일마다 무료 크레딧을 드립니다. 사용하지 않은 크레딧은 소멸되고 30일마다 재설정됩니다.</p>
                        <p>필요할 때 추가 크레딧을 구매하세요. 구매한 크레딧은 만료되지 않습니다. 크레딧 팩에 대해 자세히 알아보려면
                            <a (click)="scroll(target)" style="cursor: pointer;">여기를 클릭</a>하세요.
                        </p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="creaditsCardSection first">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>Basic</h2>
                                <span>무료 사용자</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>4</h3>
                                <p>(30일마다 무료 크레딧 제공)</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="creaditsCardSection">
                        <div class="creaditsCards boxShadowNone">
                            <div class="creaditsBoxHeader">
                                <h2>Premium</h2>
                                <span>유료 사용자</span>
                            </div>
                            <div class="creaditsToggleButton">
                                <h3>10</h3>
                                <p>(30일마다 무료 크레딧 제공)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="how_it_works">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>이렇게 사용하세요</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 30px;">1월 4일에 가입하여 베이직 플랜을 사용 중인 개인의 사용 사례를 예로 들어보겠습니다.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 1</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>무료 크레딧 잔액 열기</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>자동 파일 편집에 1크레딧 사용</td>
                                        <td style="color: red;">-1</td>
                                        <td></td>
                                        <td>3</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>무료 크레딧 잔액 재설정</td>
                                        <td style="color: red;"></td>
                                        <td style="color: green;">+4</td>
                                        <td>4</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>무료 크레딧 잔액 열기</td>
                                        <td></td>
                                        <td></td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>자동 파일 편집에 2크레딧 사용</td>
                                        <td style="color: red;">-2</td>
                                        <td></td>
                                        <td>2</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>4크레딧 팩 구매</td>
                                        <td></td>
                                        <td style="color: green;">+2</td>
                                        <td>4</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>무료 크레딧 잔액 재설정(무료 2 + 유료 4)</td>
                                        <td></td>
                                        <td style="color: green;">+4</td>
                                        <td>6</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="credit_case">
                        <div class="table table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-decoration: underline;" colspan="5">Case 3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Date</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Particulars</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Debit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Credit</td>
                                        <td style="font-weight: 600; background-color: #f8f6f9;">Balance</td>
                                    </tr>
                                    <tr>
                                        <td>05-Jan</td>
                                        <td>무료 크레딧 잔액 열기</td>
                                        <td></td>
                                        <td></td>
                                        <td>10</td>
                                    </tr>
                                    <tr>
                                        <td>10-Jan</td>
                                        <td>4크래딧 팩 구매</td>
                                        <td></td>
                                        <td style="color: green;">+2</td>
                                        <td>12</td>
                                    </tr>
                                    <tr>
                                        <td>25-Jan</td>
                                        <td>자동 파일 편집에 4크레딧 사용</td>
                                        <td style="color: red;">-4</td>
                                        <td></td>
                                        <td>8</td>
                                    </tr>
                                    <tr>
                                        <td>05-Feb</td>
                                        <td>무료 크레딧 잔액 재설정(무료 2+유료1)</td>
                                        <td></td>
                                        <td style="color: green;">+10</td>
                                        <td>12</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="credit_balance">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>
                            <sup class="">
                                <img style="width: 22px;" src="../../../../assets/images/credits_icon.png" alt="credits icon" />
                            </sup> 크레딧 잔액
                        </h2>
                        <div class="HeadingSubLine"></div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="../../../../assets/images/credits-banner1.png" alt="trinka credits" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>크레딧 잔액 확인 및 크레딧 구매</h3>
                                <p>내 크레딧 잔액은 모든 관련 페이지에 표시됩니다. 해당 값을 클릭하면 자세한 내역을 보고 크레딧을 더 구매할 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="credit_balance_wrapper">
                        <div class="credit_balance_inner">
                            <img src="../../../../assets/images/credits-banner2.png" alt="trinka credits" class="img-fluid" />
                        </div>
                        <div class="credit_balance_text">
                            <div class="credit_table">
                                <h3>트링카 기능 사용에 필요한 크레딧</h3>
                                <p>크레딧 기반 기능을 사용하는 경우 해당 기능을 사용하는 데 필요한 크레딧 수가 사용하기 전에 표시됩니다.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="buying-credit" #target>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <!-- <span class="">
                                <img src="../../../../assets/images/credits_icon.png" />
                            </span> -->
                            <h2>크레딧 구매</h2>
                            <div class="HeadingSubLine"></div>
                            <p style="margin: 0;">필요할 때마다 크레딧 팩을 구입하실 수 있습니다. 크레딧 팩을 사용하면 한 번에 복수의 크레딧을 구입했다가 언제든지 사용 가능합니다.</p>
                            <p style="margin: 0;">구매한 크레딧은 만료되지 않습니다. 대폭 할인도 해드립니다! 게다가 무료 크레딧이 항상 자동으로 먼저 사용되기에 더욱 좋습니다!</p>
                        </div>
                    </div>
                    <div class="credit_pack">
                        <div class="buyCreditTable table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">Credit Packs</th>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">
                                            <span>Basic</span>
                                            <br />
                                            <!-- <span class="comingSoonText">(Credit purchase will be available soon)</span> -->
                                        </th>
                                        <th style="font-size: 24px;color: #000000; font-weight: bold;">Premium</th>
                                    </tr>
                                </thead>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">Free monthly Credits</td>
                                    <td>4</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[0].text}}</td>
                                    <td><sup style="font-size: 13px;">{{decodedData[0].currency_code}}</sup> {{decodedData[0].final_amount / 2 | number:'1.2-2'}} <i>per credit</i></td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[0].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[0].currency_code}}</sup> {{calculatePlan(premiumDecodedData[0].final_amount, premiumDecodedData[0].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[0].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[1].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[1].currency_code}}</sup> {{calculatePlan(decodedData[1].final_amount, decodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[1].final_amount, decodedData[1].months)}}% off</span>
                                            <i>{{decodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[1].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[1].currency_code}}</sup> {{calculatePlan(premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[1].final_amount, premiumDecodedData[1].months)}}% off</span>
                                            <i>{{premiumDecodedData[1].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[2].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[2].currency_code}}</sup> {{calculatePlan(decodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[2].final_amount, decodedData[2].months)}}% off</span>
                                            <i>{{decodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[2].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[2].currency_code}}</sup> {{calculatePlan(premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[2].final_amount, premiumDecodedData[2].months)}}% off</span>
                                            <i>{{premiumDecodedData[2].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="font-size: 20px;color: #4d4d4d; font-weight: 600;">{{decodedData[3].text}}</td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{decodedData[3].currency_code}}</sup> {{calculatePlan(decodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,decodedData[3].final_amount, decodedData[3].months)}}% off</span>
                                            <i>{{decodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="credit_info">
                                            <span class="strikethrough">{{decodedData[3].currency_code}}{{decodedData[0].final_amount / 2}}</span>
                                            <sup style="font-size: 13px;">{{premiumDecodedData[3].currency_code}}</sup> {{calculatePlan(premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}
                                            <span class="yellow-btn">~{{calculateDiscountFinal(decodedData[0].final_amount/2,premiumDecodedData[3].final_amount, premiumDecodedData[3].months)}}% off</span>
                                            <i>{{premiumDecodedData[3].amount_suffix}}</i>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>팀과 기업용 크레딧</h2>
                                <!-- <div class="HeadingSubLine"></div> -->
                            </div>
                        </div>
                        <div class="others_app_name">
                            <p>트링카의 엔터프라이즈 플랜을 사용하면 필요에 따라 각 팀이나 조직이 사용할 크레딧을 구매하실 수 있습니다. 또한 엔터프라이즈 플랜을 사용하면 크레딧을 유연하게 분배하고
                                대량으로 구매할 수도 있습니다.
                            </p>
                            <a [routerLink]="['/enterprise']" routerLinkActive="active">문의하기</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>자주하는 질문</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        크레딧 구매는 환불 가능한가요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>크레딧 구매는 환불되지 않습니다. 구매한 크레딧은 사용할 때까지 유지됩니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">프리미엄으로 업그레이드하면 무료 크레딧은 어떻게 되나요?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>프리미엄으로 업그레이드하면 사용하지 않은 무료 크레딧이 얼마이든 상관없이 크레딧 잔액이 10로 재설정됩니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        프리미엄으로 업그레이드하면 구매한 크레딧은 어떻게 되나요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>구매한 크레딧은 업그레이드할 때도 그대로 유지되며, 원할 때 언제든지 사용 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        크레딧 구매에 한도가 있나요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>원하는 만큼 크레딧을 구매하실 수 있습니다. 크레딧 구매에는 제한이 없습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>